import { buttonBaseClasses } from '@mui/material'
import { type ComponentsOverrides, type Theme } from '@mui/material/styles'

export const overridesButtonBase = (theme: Theme): ComponentsOverrides['MuiButtonBase'] => ({
  root: {
    [`&.${buttonBaseClasses.disabled}`]: {
      '& svg': {
        fill: theme.palette.text.disabled,
      },
      color: theme.palette.text.disabled,
    },
  },
})
